// extracted by mini-css-extract-plugin
export var indeterminate = "_55-5";
export var md = "_55-4";
export var semantic = "_55-6";
export var sm = "_55-3";
export var text = "_55-7";
export var toggleInput = "_55-0";
export var toggleSwitch = "_55-1";
export var xs = "_55-2";